import * as React from "react";
import { makeStyles } from "@material-ui/styles";
import Typography from "@material-ui/core/Typography";
import clsx from "clsx";
import Care from "../../images/Rating/Care.png";
import ExtraMile from "../../images/Rating/ExtraMile.png";
import Friendly from "../../images/Rating/FriendlyManner.png";
import Respect from "../../images/Rating/Respect.png";
const useStyles = makeStyles(({
  palette,
  breakpoints,
  typography
}) => ({
  container: {
    marginTop: typography.pxToRem(37),
    marginBottom: typography.pxToRem(37),
    display: "flex",
    [breakpoints.down("xs")]: {
      flexWrap: "wrap",
      justifyContent: "space-between",
      marginTop: typography.pxToRem(0),
      marginBottom: typography.pxToRem(20)
    }
  },
  marginRight: {
    marginRight: typography.pxToRem(32),
    [breakpoints.down("xs")]: {
      marginRight: typography.pxToRem(0)
    }
  },
  icon: {
    maxWidth: typography.pxToRem(73),
    maxHeight: typography.pxToRem(73)
  },
  iconContainer: {
    width: typography.pxToRem(73),
    height: typography.pxToRem(73)
  },
  compliment: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    width: typography.pxToRem(147),
    position: "relative",
    [breakpoints.down("xs")]: {
      marginTop: typography.pxToRem(22)
    }
  },
  numberContainer: {
    position: "absolute",
    top: 0,
    transform: "translate(-13px, -3px)",
    width: "100%",
    display: "flex",
    justifyContent: "center"
  },
  number: {
    fontSize: typography.pxToRem(9.9),
    letterSpacing: typography.pxToRem(0.22),
    backgroundColor: "#000",
    border: "solid 0.9px #ffffff",
    padding: typography.pxToRem(2),
    paddingLeft: typography.pxToRem(4),
    paddingRight: typography.pxToRem(4),
    color: "#fff"
  },
  label: {
    fontSize: typography.pxToRem(10.8),
    letterSpacing: typography.pxToRem(0.58),
    textAlign: "center"
  }
}));

const Compliment = ({
  icon,
  number,
  label,
  className
}) => {
  const styles = useStyles();
  return /*#__PURE__*/React.createElement("div", {
    className: clsx(styles.compliment, className)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.numberContainer
  }, /*#__PURE__*/React.createElement(Typography, {
    className: styles.number
  }, number)), /*#__PURE__*/React.createElement("div", {
    className: styles.iconContainer
  }, /*#__PURE__*/React.createElement("img", {
    src: icon,
    alt: "",
    className: styles.icon
  })), /*#__PURE__*/React.createElement(Typography, {
    className: styles.label
  }, label));
};

export default (({
  compliments
}) => {
  const styles = useStyles();
  const {
    deliveredWithCare,
    wentExtraMile,
    friendlyManner,
    respectedMyProperty
  } = compliments;
  const showCompliments = deliveredWithCare || wentExtraMile || friendlyManner || respectedMyProperty;

  if (!showCompliments) {
    return null;
  }

  return /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, !!deliveredWithCare && /*#__PURE__*/React.createElement(Compliment, {
    icon: Care,
    number: deliveredWithCare,
    label: "Delivered with care",
    className: styles.marginRight
  }), !!wentExtraMile && /*#__PURE__*/React.createElement(Compliment, {
    icon: ExtraMile,
    number: wentExtraMile,
    label: "Went the extra mile",
    className: styles.marginRight
  }), !!friendlyManner && /*#__PURE__*/React.createElement(Compliment, {
    icon: Friendly,
    number: friendlyManner,
    label: "Friendly manner",
    className: styles.marginRight
  }), !!respectedMyProperty && /*#__PURE__*/React.createElement(Compliment, {
    icon: Respect,
    number: respectedMyProperty,
    label: "Respected my property"
  }));
});